import script from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppButton.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppButton.vue?vue&type=style&index=0&id=cd4f33ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd4f33ce"]])

export default __exports__